export default "__VITE_ASSET__BvuG2oId__";